module.exports = __webpack_public_path__ + "assets/advantages-delivery-dbd3c4.svg";